import { get } from 'lodash';

export const IS_PRODUCTION_SAAS_UI = process.env.REACT_APP_IS_SAAS === "true" && process.env.REACT_APP_ENDPOINTS === "prod";
export const IS_DEV_SAAS_UI = process.env.REACT_APP_IS_SAAS === "true" && process.env.REACT_APP_ENDPOINTS === "dev";
export const IS_SAAS_UI = process.env.REACT_APP_IS_SAAS === 'true';

export const getSafeModeHeaders = (featureKeys) => {
    const isSafeModeFeatureEnabled = featureKeys && featureKeys["NetApp.TenancyV4/safemode"]?.active;
    return isSafeModeFeatureEnabled ? {
        headers: {
            'Accept': 'application/vnd.netapp.bxp.user.safemode+json'
        }
    } : {};
}

/**
 * Decodes a base64url-encoded string to a regular string.
 * Handles URL-safe characters and padding required for standard base64 decoding.
 * 
 * @param {string} str - The base64url-encoded string to decode
 * @returns {string} The decoded string
 */
export const base64UrlDecode = (str) => {
    // Replace URL-safe characters
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    // Pad with '='
    while (str.length % 4) {
        str += '=';
    }
    // Decode
    return atob(str);
}

export const isNcl = () => {
    return process.env.REACT_APP_IS_NCL === "true";
}

export const isSM3 = () => {
    if (process.env.REACT_APP_IS_SAAS === "true") {
        const storeModule = require("store");
        const store = storeModule.default || storeModule;
        return get(store.getState(), 'tenancy.selectedAgent.isServiceManager3', false);
    }
    else
        return process.env.REACT_APP_IS_SM3 === "true"
}

export const isDarkSite = () => {
    return process.env.REACT_APP_IS_DARK === "true" && process.env.REACT_APP_IS_NCL !== "true";
}
